import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";

const CategoryInfo = ({ categoryInfo }) => {
   const { _id, name, description, img } = categoryInfo;
   return (
      <div className="w-full md:w-[98%] mx-auto"
         data-aos="zoom-in-left"
         data-aos-easing="ease-out-cubic"
         data-aos-duration="1700"
      >
         <Link to={`/category/${_id}`}>
            <div className="flex justify-center items-center shadow-lg px-2 lg:px-6 py-0 border rounded-xl gap-5 bg-slate-50 common">
               <LazyLoadImage
                  src={img}
                  alt={name}
                  className="w-[140px] md:w-[125px] h-[85px]  cursor-default ml-2 lg:ml-0 md:mr-3
                  px-2 lg:px-0"
                  placeholderSrc={img}
                  effect="blur"
                  title={name}
               />

               <div className="card-body w-full px-0 py-[20px] md:py-[25px] text-black">
                  <h2 className="card-title uppercase font-[900] opacity-60 hover:text-blue-600 text-[18.5px] md:text-[19.5px]">
                     {name}
                  </h2>
                  <p className="mt-[-1px] text-[15px] opacity-80">
                     <TypeAnimation
                        sequence={[`${description}`, 3000]}
                        speed={50}
                        cursor={false}
                        repeat={Infinity}
                     />
                  </p>
               </div>
            </div>
         </Link>
      </div>
   );
};

export default CategoryInfo;
